import { memberCalls2Url } from '@helpers'
import type { TicketOption } from '@/core/components/home/ticket.types'

interface TicketOptionsResponse {
    success: boolean
    data: TicketOption[]
}

// USHOP-2914: Early Bird Group (10+1) is retired. Filter it out at the fetch
// boundary so it never reaches the catalog, cards, selection, cart, or a
// bookmarked/direct URL — the whole app reads from this one source.
const RETIRED_ITEM_CODES = ['37273']

/**
 * Fetch ticket options from API
 * API: GET https://member-calls2.unicity.com/unishop-fn-misc/key_value/glic2027_ticket_periods
 * Returns array of TicketOption with pricing and period data
 */
export const fetchTicketOptions = async (): Promise<TicketOption[]> => {
    const url = memberCalls2Url({ path: '/unishop-fn-misc/key_value/glic2027_ticket_periods' })

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })

    if (!response.ok) {
        throw new Error(`Failed to fetch ticket options: ${response.status} ${response.statusText}`)
    }

    const result: TicketOptionsResponse = await response.json()

    if (!result.success || !result.data) {
        throw new Error('Invalid ticket options response')
    }

    return result.data.filter(ticket => !RETIRED_ITEM_CODES.includes(ticket.item_code))
}
